const Icon = (props: any) => {
    return (
        <svg width={16} viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M1.613 6.475c-.09-.143-.136-.215-.161-.326a.782.782 0 010-.298c.025-.11.07-.183.161-.326C2.363 4.337 4.597 1.333 8 1.333c3.404 0 5.637 3.004 6.387 4.192.09.143.136.215.162.326.019.083.019.215 0 .298-.026.11-.071.183-.162.326-.75 1.188-2.983 4.192-6.387 4.192-3.403 0-5.636-3.004-6.387-4.192z"
                stroke="currentColor"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 8a2 2 0 100-4 2 2 0 000 4z"
                stroke="currentColor"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
